// modules/import-manager-it.js
// Version italiana

import { convertToMp3FromAudioBuffer } from './audio-encoder.js';
import { i18n } from './traduction-it.js';

export async function processImportedAudio(file) {
  const arrayBuffer = await file.arrayBuffer();
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  return await convertToMp3FromAudioBuffer(audioBuffer);
}

export function setupImportOptions(config) {
  const { importButton, fileInput, getIsProMode } = config;

  const importOptions = document.createElement('div');
  importOptions.className = 'import-options';

  const importFromComputerButton = document.createElement('button');
  importFromComputerButton.textContent = i18n.btnImportFromPC;
  importFromComputerButton.setAttribute('data-icon', 'pc');
  importFromComputerButton.title = i18n.btnImportFromPC;
  importFromComputerButton.className = 'import-option-btn';

  const importFromLibraryButton = document.createElement('button');
  importFromLibraryButton.textContent = i18n.btnImportFromLib;
  importFromLibraryButton.setAttribute('data-icon', 'cloud');
  importFromLibraryButton.title = i18n.btnImportFromLib;
  importFromLibraryButton.className = 'import-option-btn';

  importOptions.appendChild(importFromComputerButton);
  importOptions.appendChild(importFromLibraryButton);

  importButton.parentNode.insertBefore(importOptions, importButton.nextSibling);
  importOptions.style.display = 'none';

  importButton.addEventListener('click', () => {
    if (!getIsProMode()) return;
    importOptions.style.display = importOptions.style.display === 'none' ? 'flex' : 'none';
  });

  importFromComputerButton.addEventListener('click', () => {
    if (!getIsProMode()) return;
    fileInput.click();
  });

  return { importOptions, importFromComputerButton, importFromLibraryButton };
}

export function createLibraryModal(onSelectSound) {
  const libraryModal = document.createElement('div');
  libraryModal.className = 'library-modal';
  libraryModal.innerHTML = `
    <div class="library-content">
      <h3>${i18n.libraryTitle}</h3>
      <div class="library-source-info">Fonte: <span id="sound-source-info">${i18n.librarySourceAll}</span></div>

      <div class="library-filters">
        <label>Filtra per categoria:</label>
        <select id="category-filter">
          <option value="all">${i18n.categoryAll}</option>
          <option value="generique">${i18n.categoryGenerique}</option>
          <option value="jingle">${i18n.categoryJingle}</option>
          <option value="virgule">${i18n.categoryVirgule}</option>
          <option value="divers">${i18n.categoryDivers}</option>
        </select>
      </div>

      <div class="library-sounds-container"></div>
      <button class="close-library-btn">${i18n.libraryClose}</button>
    </div>
  `;
  document.body.appendChild(libraryModal);

  const closeBtn = libraryModal.querySelector('.close-library-btn');
  closeBtn.addEventListener('click', () => {
    libraryModal.style.display = 'none';
    stopAllPreviews();
  });

  const categoryFilter = libraryModal.querySelector('#category-filter');
  categoryFilter.addEventListener('change', function() {
    loadLibrarySounds(this.value, libraryModal, onSelectSound);
  });

  const showLibrary = () => {
    loadLibrarySounds('all', libraryModal, onSelectSound);
    libraryModal.style.display = 'flex';
  };

  return { libraryModal, showLibrary };
}

async function loadLibrarySounds(categoryFilter, libraryModal, onSelectSound) {
  const libraryContainer = libraryModal.querySelector('.library-sounds-container');
  libraryContainer.innerHTML = `<p>${i18n.libraryLoading}</p>`;

  try {
    const response = await fetch('./librairie/sounds-list.json');
    const allSounds = await response.json();

    const soundsList = categoryFilter === 'all'
      ? allSounds
      : allSounds.filter(sound => sound.category === categoryFilter);

    const sourceInfo = libraryModal.querySelector('#sound-source-info');
    sourceInfo.textContent = categoryFilter === 'all'
      ? i18n.librarySourceAll
      : i18n.librarySourceCat(categoryFilter);

    libraryContainer.innerHTML = '';

    if (soundsList.length === 0) {
      libraryContainer.innerHTML = `<p>${i18n.libraryEmpty}</p>`;
      return;
    }

    soundsList.forEach(sound => {
      libraryContainer.appendChild(createSoundElement(sound, categoryFilter, onSelectSound, libraryModal));
    });
  } catch (error) {
    console.error('Errore durante il caricamento della libreria', error);
    libraryContainer.innerHTML = `<p>${i18n.libraryError}</p>`;
  }
}

function createSoundElement(sound, categoryFilter, onSelectSound, libraryModal) {
  const soundElement = document.createElement('div');
  soundElement.className = 'library-sound-item';
  soundElement.innerHTML = `
    <div class="sound-info">
      <span class="sound-name">${sound.name}</span>
      <div class="sound-details">
        <span class="sound-duration">${sound.duration}</span>
        <span class="sound-category">${sound.category}</span>
        <span class="sound-source">${sound.source || 'Fonte sconosciuta'}</span>
      </div>
    </div>
    <div class="sound-controls">
      <button class="preview-sound-btn" data-src="${sound.src}">
        <span class="play-icon">▶</span>
        <span class="pause-icon" style="display:none">⏸</span>
      </button>
      <button class="select-sound-btn" data-src="${sound.src}">+</button>
    </div>
  `;

  const previewButton = soundElement.querySelector('.preview-sound-btn');
  const playIcon = previewButton.querySelector('.play-icon');
  const pauseIcon = previewButton.querySelector('.pause-icon');
  let audioPreview = null;

  previewButton.addEventListener('click', () => {
    if (!audioPreview) {
      stopAllPreviews();
      audioPreview = new Audio(sound.src);

      document.getElementById('sound-source-info').textContent =
        i18n.libraryListening(sound.name, sound.source || 'Fonte sconosciuta');

      audioPreview.onended = () => {
        playIcon.style.display = 'inline';
        pauseIcon.style.display = 'none';
        document.getElementById('sound-source-info').textContent =
          categoryFilter === 'all' ? i18n.librarySourceAll : i18n.librarySourceCat(categoryFilter);
      };

      audioPreview.play();
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'inline';
    } else if (audioPreview.paused) {
      audioPreview.play();
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'inline';
    } else {
      audioPreview.pause();
      playIcon.style.display = 'inline';
      pauseIcon.style.display = 'none';
    }
  });

  soundElement.querySelector('.select-sound-btn').addEventListener('click', async () => {
    stopAllPreviews();
    await onSelectSound(sound.src, sound.name);
  });

  return soundElement;
}

function stopAllPreviews() {
  document.querySelectorAll('.preview-sound-btn').forEach(button => {
    button.querySelector('.play-icon').style.display = 'inline';
    button.querySelector('.pause-icon').style.display = 'none';
  });
  document.querySelectorAll('audio').forEach(audio => audio.pause());
}